import { BuchungService } from "./BuchungService";

class WehnService {constructor() { WehnService.prototype.__init.call(this); }
   __init() {this.buchung = new BuchungService()}
}

export const $wehn = new WehnService();
